import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 27px 20px 29px;
  background-color: #ffffff;
  border-radius: 6px;
  margin: 12px;

  @media screen and (min-width: ${DESKTOP}px) {
    max-width: 355px;
  }
`;
